import React, { useContext, useMemo } from 'react';
import flush from 'just-flush';
import { CertificationsGrid } from '@stereoagency/ui';
import type { ILazyBlocksImage } from '@/types';
import { useMediaItems } from '@/hooks';
import { LinesContext } from '@/components/LinesContext';

type Props = {
  data: {
    label?: string
    title: string
    certifications: {
      logo?: ILazyBlocksImage
      label?: string
    }[]
  }
};

export default function NvisoCertifications({ data: { label, title, certifications } }: Props) {
  const { enableLines } = useContext(LinesContext);
  const mediaItemIds = useMemo(() => (
    flush(certifications.map(({ logo }) => logo ? logo.id : null))
  ), [certifications]);
  const mediaItems = useMediaItems(mediaItemIds);

  return (
    <CertificationsGrid
      enableLines={enableLines}
      label={label}
      title={title}
      certifications={flush(certifications.map((item) => {
        const mediaItem = item.logo ? mediaItems.get(item.logo.id) : null;

        if (!mediaItem) {
          return null;
        }

        return {
          label: item.label ?? undefined,
          logo: {
            src: mediaItem.mediaItemUrl ?? '',
            width: mediaItem.mediaDetails?.width ?? 120,
            height: mediaItem.mediaDetails?.height ?? 120,
          },
        };
      }))}
    />
  );
}
